import { render, staticRenderFns } from "./BoxRadarChart.vue?vue&type=template&id=952df66a&"
import script from "./BoxRadarChart.vue?vue&type=script&lang=js&"
export * from "./BoxRadarChart.vue?vue&type=script&lang=js&"
import style0 from "./BoxRadarChart.vue?vue&type=style&index=0&id=952df66a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QTooltip,QSeparator,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon,QTooltip,QSeparator,QInnerLoading,QSpinnerTail})
